@if (edited) {
  <p>User successfully remote logged in</p>
}
<div class="col-xs-6">
  @if (edited) {
    <button
      mat-raised-button
      color="primary"
      id="remoteLogout"
      matTooltip="Logout"
      (click)="onCancel()"
      >
      {{translatedLabels['data.Code.Transaction_Cd.Code_Desc.LGOT']}}
    </button>
  }
</div>
